import styled from 'styled-components';

import { COLOR_CONFIG } from 'constants/color';

export const Container = styled.div`
  display: flex;
  height: 100vh;
`;

export const Menu = styled.div`
  height: 100%;
  position: relative;
  transition: width 0.5s;
`;

export const Content = styled.div`
  flex-grow: 1;
  height: 100%;
  padding: 32px 32px 80px 32px;
  background-color: ${COLOR_CONFIG.white};
  overflow: auto;
`;

export const StyleIconArrow = styled.div`
  height: 100%;

  svg path[stroke] {
    stroke: #ffffff;
  }
  svg path[fill] {
    fill: #ffffff;
  }
`;
